import FullPageLayout from '../components/FullPageLayout';
import Error404 from '../pages/Error404';

import publicRoutes from './public-routes';
import {
	employeeFullPageRoutes,
	employeeHorizontalRoutes,
} from './employee-routes';
import {
	adminFullPageRoutes,
	adminVerticalRoutes,
} from './admin-routes';
import {
	thirdPartyFullPageRoutes,
	thirdPartyHorizontalRoutes,
} from './third-party-routes';

/**
 * Auth-protected routes outside persistent layout shells.
 * Admin / employee / third-party shells are wired separately in App.js.
 */
const authProtectedRoutes = [
	...employeeFullPageRoutes,

	{
		path: '*',
		exact: true,
		component: Error404,
		layout: FullPageLayout,
	},
];

export {
	authProtectedRoutes,
	publicRoutes,
	adminVerticalRoutes,
	adminFullPageRoutes,
	employeeHorizontalRoutes,
	employeeFullPageRoutes,
	thirdPartyHorizontalRoutes,
	thirdPartyFullPageRoutes,
};
